import '../assets/fonts/fonts.css';

export default {
  dank: 'font-family: Dank Mono'
};
